<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">        
        <div class="u-window m-discountDetail-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="layer-header"></div>
            <div class="dialog-wrapper">
                <div class="t-discount"></div>
                <div class="discount-detail">
                    <ul v-if="player_list.length">
                        <li class="clearfix" v-for="(player,index) in player_list" :key="index">
                            <div class="player-name f-l">
                                {{ player.name.replace(/\x7F+/g,"")}}
                                <em class="icon-first" v-if="player.mode == 1"></em>
                                <em class="icon-best" v-if="player.mode == 2"></em>
                            </div>
                            <div class="cnt f-r">
                                <em class="icon-m3b"></em>
                                {{ player.discount }}
                            </div>
                        </li>
                    </ul>
                    <div class="notice" v-else>暂无好友帮砍哦！</div>
                </div>
                 
                <button v-if="player_list.length < 2 && price <= 2000" class="u-btn copy" data-clipboard-action="copy" :data-clipboard-text="shareTxt | temp" @click="copy"></button>
                <button v-if="player_list.length < 1 && price > 2000" class="u-btn copy" data-clipboard-action="copy" :data-clipboard-text="shareTxt | temp" @click="copy"></button>
                <button v-if="player_list.length == 2 && price <= 2000" class="u-btn read" @click="destroyElement"></button>
                <button v-if="player_list.length == 1 && price > 2000" class="u-btn read" @click="destroyElement"></button>

            </div>
            <div class="layer-bottom"></div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<script>
export default {
    data () {
        return {
            dialogVisible : false,
            player_list: [],
            price: 0,
            shareTxt: '加载中',
            key: '',
        }
    },
    created (){
        //this.render();
    },
    filters : {
        temp (value){
            if(value)return value;
            return '【阿斗赶集】花自飘零水自流。一种相思，两处闲愁。快来帮帮乔乔吧~' + _this.$global.domain + '?key=' + this.key
        }
    },
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              _this.$toast("复制成功");
            });
            clipboard.on('error', function () {
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },
        render() {
            var _this = this;
            this.$axios.post(this.$ajax_url_map.share,this.$qs.stringify({
                id: _this.gid,
                r : +new Date(),               
            }))
            .then(res => {
                _this.shareTxt = res.data.content ? res.data.content : ('【阿斗赶集】花自飘零水自流。一种相思，两处闲愁。快来帮帮乔乔吧~' + _this.$global.domain + '?key=' + res.data.key)
            },rej => {
                _this.$toast('请稍后再试')
                _this.shareTxt = '请稍后再试'
            });
        },       
    },
}
</script>

<style scoped>
/* discountDetail */
.m-discountDetail-modal .dialog-wrapper{
    width: 709px;
    min-height: 467px;
    margin-top: -1px;
    padding: 10px 20px;
    background-image: url(~@/assets/images/utils/modal-dis-body.png);
    background-repeat: repeat-y;
    background-size: 750px auto;
    box-shadow: none;
}

.layer-header{
    width: 709px;
    height: 35px;
    background-size: 709px auto;
    background-image: url(~@/assets/images/utils/modal-dis-top.png);
}

.layer-bottom{
    width: 709px;
    height: 37px;
    margin-top: -3px;
    background-size: 709px auto;
    background-image: url(~@/assets/images/utils/modal-dis-bottom.png);
}

.t-discount {
    width: 511px;
    height: 50px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/utils/title-discount.png);
}

.discount-detail{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 270px;
}

.discount-detail ul{
    height: 100%;
}

.discount-detail .notice{
    width: 100%;
    font-size: 32px;
    font-weight: 700;
    text-align: center;
}

.m-discountDetail-modal .u-btn.copy {
    width: 364px;
    height: 74px;
    background-image: url(~@/assets/images/utils/btn-copy-discount.png);
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
}

.m-discountDetail-modal .u-btn.read{
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);    
}



</style>



// WEBPACK FOOTER //
// src/components/DiscountDetail/discountDetail.vue